import { render } from "./Add.vue?vue&type=template&id=5c1379f4&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import "./Add.vue?vue&type=style&index=0&id=5c1379f4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/central-front/central-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1379f4"]])

export default __exports__